<template>
    <div class="interval z-10" :class="bg + (!favorable ? ' unfavorable' : '')" 
      :style="'width:'+width+'px;left:'+x+'px;'">
      <div class="text" :style="'left:'+textX+'px;width:'+textWidth+'px;'">
        <div class="title" v-html="title"></div>
        <div class="description">{{ description }}</div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['title', 'description', 'bg', 'favorable', 'start', 'length', 'scale', 'zero', 'visibleLeft'],
  data() {
    return {
      xDivider: 2,
      xPadding: 11,
      minWidth: 20,
    }
  },
  computed: {
    x() {
      return Math.floor((this.start - this.zero) / this.scale) + this.xDivider
    },
    textX() {
      if (this.isLeftClipped)
        return this.visibleLeft - this.x + this.xPadding
      return this.xPadding;
    },
    width() {
      return Math.floor(this.length / this.scale) - 2 * this.xDivider
    },
    textWidth() {
      if (this.isLeftClipped) {
        var width = this.width - (this.visibleLeft - this.x) - 2 * this.xPadding
        return (width > this.minWidth) ? width : 0
      }
      return this.width - 2 * this.xPadding;
    },
    isLeftClipped() {
      return (this.x < this.visibleLeft && this.x + this.width > this.visibleLeft + this.xPadding)
    },
  },
}
</script>
